// ── Step 6 Suggestion Empty State — Pure DOM writes, no state or API ──────

function createSuggestionElement(tagName, className = '', text = null) {
  const element = document.createElement(tagName);
  if (className) element.className = className;
  if (text !== null) element.textContent = text;
  return element;
}

function splitAdvicePoints(text = '') {
  let lines = String(text).split(/\n+/).map((line) => line.trim()).filter(Boolean);
  if (lines.length === 1 && lines[0].length > 60) {
    lines = lines[0].split(/(?<=[。；;！!？?])\s*/).map((line) => line.trim()).filter(Boolean);
  }
  return lines.length <= 1
    ? lines
    : lines.map((line) => line.replace(/^(\d+[.、．)\s]|第[\d一二三四五六七八九十]+[，,、.\s])/, '').trim());
}

function createAdvicePoints(text) {
  const points = createSuggestionElement('div', 'revision-review-summary revision-advice-points diagnostic-raw-copy-body');
  splitAdvicePoints(text).forEach((line, index, lines) => {
    const point = createSuggestionElement('div', 'revision-advice-point');
    if (lines.length > 1) point.append(createSuggestionElement('span', 'revision-advice-idx', `第${index + 1}点`));
    point.append(document.createTextNode(line));
    points.append(point);
  });
  return points;
}

/** Renders only the no-card state; card rendering and event binding stay in Step 6. */
export function renderRevisionSuggestionsEmptyInto(root, { revisionAdviceText = '', suggestionsError = '' } = {}) {
  if (!root) return;
  const empty = createSuggestionElement('div', 'revision-empty');
  if (revisionAdviceText) {
    empty.append(createSuggestionElement(
      'p',
      'revision-empty-text',
      '已生成可执行改稿指令。系统会按上方“必须修改”和“系统将怎么改”生成候选稿，并在写回前完成安全检查。',
    ));
    const details = createSuggestionElement('details', 'diagnostic-raw-copy revision-advice-raw-copy');
    details.append(createSuggestionElement('summary', '', '查看原始改稿指令（高级）'), createAdvicePoints(revisionAdviceText));
    empty.append(details);
  } else {
    empty.append(
      createSuggestionElement('div', 'revision-empty-icon', suggestionsError ? '⚠️' : '✨'),
      createSuggestionElement('p', 'revision-empty-text', suggestionsError || '恭喜！当前 Listing 没有需要修改的问题。'),
    );
  }
  root.replaceChildren(empty);
}
